import React from 'react';
import TechnologyDetail from '../../BasicComponents/TechnologyDetail';

const TenantTechnologyDetail = () => {
  return <TechnologyDetail mode="tenant" />;
};

export default TenantTechnologyDetail;
